export const ROUTE_EMBEDDED_FORMS = '/embedded-forms';
export const SUBROUTE_CREATE_EMBEDDED_FORM = '/create';
export const SUBROUTE_EDITOR = '/editor';
// Path slot under /admin/templates where the EF template editor lives
// (full URL: /admin/templates/embedded-forms/:slug). Mirrors LP/popup/BIS.
export const SUBROUTE_ADMIN_TEMPLATES = '/embedded-forms';

export const EMBEDDED_FORMS_QUERY_KEY_PREFIX = 'embedded-forms';

export const SUBROUTE_SCHEDULE = '/schedule';
export const EMBEDDED_FORM_SCHEDULE_EVENTS_QUERY_KEY_PREFIX =
  'embedded-form-schedule-events';
export const LARGE_ENTITY_FETCH_LIMIT = 100;

export const LIST_BREADCRUMB_TEXT = 'View all embedded forms';
